<template>
  <b-form novalidate class="mb-5">
    <!-- Nombre -->
    <b-form-group id="nameGroup" label="Nombre:" label-for="name">
      <b-form-input
          id="name"
          name="name"
          type="text"
          v-model.trim="client.name"
          v-validate="'required'"
          required
          :state="errors.first('name') ? 'invalid' : ''"
          placeholder="Nombre"/>
      <b-form-invalid-feedback id="feedback-name">{{ errors.first('name') }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- Telefono -->
    <b-form-group id="phoneGroup" label="Teléfono contacto:" label-for="phone">
      <b-form-input
          id="phone"
          name="phone"
          type="number"
          v-model.trim="client.phone"
          v-validate="'required'"
          required
          :state="errors.first('phone') ? 'invalid' : ''"
          placeholder="Teléfono"/>
      <b-form-invalid-feedback id="feedback-phone">{{ errors.first('phone') }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- Persona de Contacto -->
    <b-form-group id="contactPersonGroup" label="Persona de contacto:" label-for="name">
      <b-form-input
        id="contactPerson"
        name="contactPerson"
        type="text"
        v-model.trim="client.contactPerson"
        v-validate="'required'"
        required
        :state="errors.first('contactPerson') ? 'invalid' : ''"
        placeholder="Persona de contacto"/>
      <b-form-invalid-feedback id="feedback-contactPerson">{{ errors.first('contactPerson') }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- Dirección -->
    <b-form-group id="addressGroup" label="Dirección:" label-for="address">
      <b-form-input
          id="address"
          name="address"
          type="text"
          v-model="client.address"
          v-validate="'required'"
          :state="errors.first('address') ? 'invalid' : ''"
          placeholder="Dirección"/>
      <b-form-invalid-feedback id="feedback-address">{{ errors.first('address') }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- Email -->
    <b-form-group
        id="emailGroup"
        label="Email:"
        label-for="exampleInput1"
        description="Email del cliente">
      <b-form-input
          id="email"
          name="email"
          type="email"
          v-model="client.email"
          v-validate="'email'"
          :state="errors.first('email') ? 'invalid' : ''"
          placeholder="Email"/>
      <b-form-invalid-feedback id="feedback-email">{{ errors.first('email') }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- Forma de Pago -->
    <b-form-group id="paymentMethodGroup" label="Forma de Pago:" label-for="paymentMethod">
      <b-form-input
          id="paymentMethod"
          name="paymentMethod"
          type="text"
          v-model="client.paymentMethod"
          v-validate="'required'"
          :state="errors.first('paymentMethod') ? 'invalid' : ''"
          placeholder="Forma de Pago"/>
      <b-form-invalid-feedback id="feedback-paymentMethod">{{ errors.first('paymentMethod') }}</b-form-invalid-feedback>
    </b-form-group>

    <!-- Precios / Producto -->
    <hr>
    <b-form-group id="productPricesGroup" label="Productos" label-for="productName-0">
      <b-row>
        <template v-for="(item, index) in client.productPrices">
          <b-col sm="12" :key="`label-${index}`">
            <label :for="`productName-${index}`">
              <b-badge variant="light">
                Producto · {{index}}
              </b-badge>
            </label>
          </b-col>
          <b-col sm="5" :key="`id-${index}`" class="mb-1">
            <b-input-group>
              <b-form-select
                :id="`productName-${index}`"
                :name="`productName-${index}`"
                v-model="client.productPrices[index].id"
                :state="errors.first(`productName-${index}`) ? 'invalid' : ''"
                v-validate="'required'"
              >
                <option :value="null">--Elige Producto--</option>
                <option v-for="(product, idx) in productsFormatted" :value="product.value" :key="idx">{{product.text}}
                </option>
              </b-form-select>
              <b-form-invalid-feedback :id="`feedback-productName-${index}`">{{ errors.first(`productName-${index}`) }}</b-form-invalid-feedback>
            </b-input-group>
          </b-col>
          <b-col sm="5" :key="`price-${index}`" class="mb-1">
            <b-input-group :id="`group-price-product-${index}`" prepend="€" description="Let us know your name.">
              <b-form-input
                :id="`price-product-${index}`"
                :name="`price-product-${index}`"
                type="number"
                v-model.trim="client.productPrices[index].price"
                v-validate="'required|decimal:2'"
                :state="errors.first(`price-product-${index}`) ? 'invalid' : ''"
                :placeholder="`Formato: 12.34`"/>
              <b-form-invalid-feedback :id="`feedback-price-product-${index}`">{{ errors.first(`price-product-${index}`) }}</b-form-invalid-feedback>
            </b-input-group>
          </b-col>
          <b-col sm="2" :key="`button-${index}`">
            <b-button
                v-if="moreThanOneProduct"
                @click="deleteProductByIndex"
                variant="outline-primary"
                class="mb-3">
              <font-awesome-icon icon="trash-alt"/>
            </b-button>
          </b-col>
        </template>
      </b-row>
      <b-button
          @click="addProduct"
          :class="{'mt-3': !moreThanOneProduct}"
          variant="secondary"
          size="sm">
        Añadir Producto
        <font-awesome-icon icon="fire-alt"/>
      </b-button>
    </b-form-group>

    <!-- Horario Entrega -->
    <hr>
    <b-form-group
      id="devileryScheduleGroup"
      label="Horario de Entrega"
      label-for="deliveryScheduleStartTime-0">
      <b-row>
        <template v-for="(item, index) in client.deliverySchedule">
          <b-col sm="12" :key="`TitleDeliverySchedule-${index}`">
            <label :for="`startTime-${index}`">
              <b-badge variant="light">
                Horario de Entrega · {{index}}
              </b-badge>
            </label>
          </b-col>
          <b-col sm="5" :key="`deliveryScheduleStartTime-${index}`" class="mb-1">
            <b-input-group>
              <b-input-group-prepend is-text>
                <font-awesome-icon icon="clock"/>
              </b-input-group-prepend>
              <b-form-input
                  :id="`deliveryScheduleStartTime-${index}`"
                  :name="`deliveryScheduleStartTime-${index}`"
                  type="text"
                  v-validate="{ required: true, regex: /([01]?[0-9]|2[0-3]):[0-5][0-9]/, max: 5 }"
                  :state="errors.first(`deliveryScheduleStartTime-${index}`) ? 'invalid' : ''"
                  v-model="client.deliverySchedule[index].startTime"
                  placeholder="HH:mm Inicio"
              />
              <b-form-invalid-feedback :id="`feedback-deliveryScheduleStartTime-${index}`">{{ errors.first(`deliveryScheduleStartTime-${index}`) }}</b-form-invalid-feedback>
            </b-input-group>
          </b-col>
          <b-col sm="5" :key="`deliveryScheduleEndTime-${index}`" class="mb-1">
            <b-input-group>
              <b-input-group-prepend is-text>
                <font-awesome-icon icon="clock"/>
              </b-input-group-prepend>
              <b-form-input
                  :id="`deliveryScheduleEndTime-${index}`"
                  :name="`deliveryScheduleEndTime-${index}`"
                  type="text"
                  v-validate="{ required: true, regex: /([01]?[0-9]|2[0-3]):[0-5][0-9]/, max: 5 }"
                  :state="errors.first(`deliveryScheduleEndTime-${index}`) ? 'invalid' : ''"
                  v-model="client.deliverySchedule[index].endTime"
                  placeholder="HH:mm Fin"
              />
              <b-form-invalid-feedback :id="`feedback-deliveryScheduleEndTime-${index}`">{{ errors.first(`deliveryScheduleEndTime-${index}`) }}</b-form-invalid-feedback>
            </b-input-group>
          </b-col>
          <b-col sm="2" :key="`deliveryScheduleButton-${index}`">
            <b-button
                v-if="moreThanOneDelivery"
                @click="deleteDeliveryScheduleByIndex"
                variant="outline-primary"
                class="mb-3">
              <font-awesome-icon icon="trash-alt"/>
            </b-button>
          </b-col>
        </template>
      </b-row>
      <b-button
          @click="addDeliverySchedule"
          :class="{'mt-3': !moreThanOneDelivery}"
          variant="secondary"
          size="sm">
        Añadir Horario
        <font-awesome-icon icon="clock"/>
      </b-button>
    </b-form-group>

    <hr>
    <!-- Metodo Entrega -->
    <b-form-group label="Frecuencia Entrega">
      <b-form-checkbox-group
          stacked
          v-model="client.deliveryFrequency"
          name="deliveryMethod"
          :state="client.deliveryFrequency.length === 0 ? 'invalid' : ''"
          :options="deliveryFrequencies"/>
      <span class="text-danger" v-if="client.deliveryFrequency.length === 0" id="feedback-deliveryMethod">Elije al menos una forma de pago</span>
    </b-form-group>

    <br>
    <!-- Notas Adicinales -->
    <b-form-group id="notesGroup" label="Notas Adicionales:" label-for="notes">
      <b-form-textarea
          v-model="client.notes"
          id="notes"
          placeholder="Comentarios extra"
          rows="3"/>
    </b-form-group>

    <hr>
    <b-button @click="validateForm" variant="primary">
      <template v-if="isNewClient">
        Crear Cliente
      </template>
      <template v-else>
        Actualizar cliente
      </template>
      <b-spinner v-if="createClientLoading" small type="grow" label="Spinning"/>
    </b-button>

  </b-form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClientForm',
  props: {
    products: {
      type: Array,
      required: true
    },
    client: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      deliveryFrequencies: [
        { text: 'Semanal', value: 'weekly' },
        { text: 'Quincenal', value: 'biweekly' },
        { text: 'Llama', value: 'call' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'createClientLoading'
    ]),
    productsFormatted () {
      return this.products.map(item => {
        return {
          value: item.id,
          text: item.name
        }
      })
    },
    moreThanOneProduct () {
      return this.client.productPrices.length > 1
    },
    moreThanOneDelivery () {
      return this.client.deliverySchedule.length > 1
    },
    isNewClient () {
      return this.$route.name === 'ClientNew'
    }
  },
  methods: {
    deleteProductByIndex (index) {
      this.client.productPrices.splice(index, 1)
    },
    addProduct () {
      this.client.productPrices.push({ id: '', price: 0 })
    },
    deleteDeliveryScheduleByIndex (index) {
      this.client.deliverySchedule.splice(index, 1)
    },
    addDeliverySchedule () {
      this.client.deliverySchedule.push({ startTime: '', endTime: '' })
    },
    validateForm () {
      this.$validator.validateAll()
        .then((result) => {
          // Custom validation
          if (this.client.deliveryFrequency.length > 0) {
            if (result) {
              this.isNewClient ? this.onCreate() : this.onUpdate()
            }
          }
        })
    },
    onCreate () {
      this.$emit('onCreate', this.client)
    },
    onUpdate () {
      this.$emit('onUpdate', this.client)
    }
  }
}
</script>
